import React from 'react';
import Icon from 'components/AppIcon';

const ContactInfo = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Hola, me interesa obtener información sobre sus servicios de limpieza de piscinas.');
    window.open(`https://wa.me/50686423175?text=${message}`, '_blank');
  };

  const handleEmailClick = () => {
    window.location.href = 'mailto:info@bacpoolcr.online';
  };

  const handlePhoneClick = () => {
    window.location.href = 'tel:+50622534791';
  };

  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl font-heading font-bold text-text-primary mb-6">
          Información de Contacto
        </h2>
        <p className="text-text-secondary mb-8">
          Estamos ubicados en el corazón de Costa Rica, listos para atender todas tus necesidades 
          de limpieza y mantenimiento de piscinas. Contáctanos por cualquiera de estos medios.
        </p>
      </div>

      {/* Contact Methods */}
      <div className="space-y-6">
        {/* Phone */}
        <div className="flex items-start space-x-4">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="Phone" size={20} className="text-primary" />
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-text-primary mb-1">Teléfono Principal</h3>
            <button
              onClick={handlePhoneClick}
              className="font-mono text-primary hover:text-primary/80 nav-transition"
            >
              +506 2253-4791
            </button>
            <p className="text-sm text-text-secondary mt-1">
              Lunes a Sábado: 7:00 AM - 6:00 PM
            </p>
          </div>
        </div>

        {/* WhatsApp */}
        <div className="flex items-start space-x-4">
          <div className="w-12 h-12 bg-success/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="MessageCircle" size={20} className="text-success" />
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-text-primary mb-1">WhatsApp</h3>
            <button
              onClick={handleWhatsAppClick}
              className="font-mono text-success hover:text-success/80 nav-transition"
            >
              +506 8642-3175
            </button>
            <p className="text-sm text-text-secondary mt-1">
              Respuesta rápida disponible 24/7
            </p>
          </div>
        </div>

        {/* Email */}
        <div className="flex items-start space-x-4">
          <div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="Mail" size={20} className="text-accent" />
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-text-primary mb-1">Correo Electrónico</h3>
            <button
              onClick={handleEmailClick}
              className="text-accent hover:text-accent/80 nav-transition"
            >
              info@bacpoolcr.online
            </button>
            <p className="text-sm text-text-secondary mt-1">
              Respuesta dentro de 24 horas
            </p>
          </div>
        </div>

        {/* Address */}
        <div className="flex items-start space-x-4">
          <div className="w-12 h-12 bg-secondary/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="MapPin" size={20} className="text-secondary" />
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-text-primary mb-1">Dirección</h3>
            <p className="text-text-secondary">
              Centro Comercial Plaza Roble
              <br />
              Escazú, San José, Costa Rica
              <br />
              Oficina 234, Segundo Piso
            </p>
          </div>
        </div>
      </div>

      {/* Business Hours */}
      <div className="bg-surface rounded-lg border border-border p-6">
        <h3 className="font-semibold text-text-primary mb-4 flex items-center">
          <Icon name="Clock" size={20} className="text-primary mr-2" />
          Horarios de Atención
        </h3>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span className="text-text-secondary">Lunes - Viernes:</span>
            <span className="text-text-primary font-medium">7:00 AM - 6:00 PM</span>
          </div>
          <div className="flex justify-between">
            <span className="text-text-secondary">Sábado:</span>
            <span className="text-text-primary font-medium">8:00 AM - 4:00 PM</span>
          </div>
          <div className="flex justify-between">
            <span className="text-text-secondary">Domingo:</span>
            <span className="text-error font-medium">Cerrado</span>
          </div>
          <div className="pt-2 border-t border-border mt-3">
            <div className="flex items-center space-x-2">
              <Icon name="AlertCircle" size={16} className="text-warning" />
              <span className="text-xs text-text-secondary">
                Servicios de emergencia disponibles 24/7
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Service Areas */}
      <div className="bg-surface rounded-lg border border-border p-6">
        <h3 className="font-semibold text-text-primary mb-4 flex items-center">
          <Icon name="Map" size={20} className="text-primary mr-2" />
          Áreas de Servicio
        </h3>
        <div className="grid grid-cols-2 gap-2 text-sm">
          <div className="flex items-center space-x-2">
            <Icon name="Check" size={14} className="text-success" />
            <span className="text-text-secondary">San José Centro</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Check" size={14} className="text-success" />
            <span className="text-text-secondary">Escazú</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Check" size={14} className="text-success" />
            <span className="text-text-secondary">Santa Ana</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Check" size={14} className="text-success" />
            <span className="text-text-secondary">Cartago</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Check" size={14} className="text-success" />
            <span className="text-text-secondary">Heredia</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Check" size={14} className="text-success" />
            <span className="text-text-secondary">Alajuela</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Check" size={14} className="text-success" />
            <span className="text-text-secondary">Tres Ríos</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Check" size={14} className="text-success" />
            <span className="text-text-secondary">Curridabat</span>
          </div>
        </div>
        <p className="text-xs text-text-secondary mt-3">
          ¿No ves tu área? Contáctanos para consultar disponibilidad.
        </p>
      </div>

      {/* Map */}
      <div className="bg-surface rounded-lg border border-border overflow-hidden">
        <div className="h-64">
          <iframe
            width="100%"
            height="100%"
            loading="lazy"
            title="BAC Pool CR Location"
            referrerPolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps?q=9.9281,-84.0907&z=12&output=embed"
            className="border-0"
          />
        </div>
        <div className="p-4">
          <p className="text-sm text-text-secondary">
            Ubicados estratégicamente en Escazú para servir toda el área metropolitana
          </p>
        </div>
      </div>

      {/* Social Media */}
      <div className="bg-surface rounded-lg border border-border p-6">
        <h3 className="font-semibold text-text-primary mb-4 flex items-center">
          <Icon name="Share2" size={20} className="text-primary mr-2" />
          Síguenos en Redes Sociales
        </h3>
        <div className="flex space-x-4">
          <a
            href="https://facebook.com/bacpoolcr"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center w-10 h-10 bg-blue-600 text-white rounded-lg hover:bg-blue-700 nav-transition"
          >
            <Icon name="Facebook" size={20} />
          </a>
          <a
            href="https://instagram.com/bacpoolcr"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center w-10 h-10 bg-pink-600 text-white rounded-lg hover:bg-pink-700 nav-transition"
          >
            <Icon name="Instagram" size={20} />
          </a>
          <a
            href="https://wa.me/50686423175"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center w-10 h-10 bg-green-600 text-white rounded-lg hover:bg-green-700 nav-transition"
          >
            <Icon name="MessageCircle" size={20} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
